import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { contributionRequest } from "../lib/contribution-client";
export function SupportStatusPage() {
	const [receipts, setReceipts] = useState<Array<{
			id: string;
			state: string;
			decision_note: string;
			updated_at: string;
		}> | null>(null),
		[error, setError] = useState(""),
		[retry, setRetry] = useState(0);
	useEffect(() => {
		let live = true;
		contributionRequest<{ receipts: NonNullable<typeof receipts> }>(
			"/api/receipts",
		)
			.then((d) => {
				if (live) {
					setReceipts(d.receipts);
					setError("");
				}
			})
			.catch((e) => {
				if (live) setError(e.message);
			});
		return () => {
			live = false;
		};
	}, [retry]);
	const labels: Record<string, string> = {
		received: "접수했어요",
		reviewing: "확인 중이에요",
		reflected: "반영했어요",
		kept: "기존 내용을 유지했어요",
		hidden: "숨김 처리했어요",
		removed: "삭제했어요",
		corrected: "고쳤어요",
		decided: "처리를 마쳤어요",
		closed: "처리를 마쳤어요",
	};
	return (
		<section className="page narrow stack-lg">
			<h1>보낸 제보 확인</h1>
			<p>
				이 기기 열쇠로 보낸 신고·정정 제보만 보여요. 다른 기기에서 보냈다면
				열쇠가 담긴 백업을 복원해 주세요.
			</p>
			{error ? (
				<p role="alert">
					{error}
					<button className="button" onClick={() => setRetry(retry + 1)}>
						다시 확인하기
					</button>
				</p>
			) : receipts === null ? (
				<p role="status">처리 상태를 불러오고 있어요.</p>
			) : receipts.length ? (
				receipts.map((r) => (
					<article className="tip-item" key={r.id}>
						<h2>
							{labels[r.decision_note] ?? labels[r.state] ?? "확인 중이에요"}
						</h2>
						<p>
							{r.decision_note && !labels[r.decision_note]
								? r.decision_note
								: ""}
						</p>
						<p className="micro">
							접수 번호 {r.id} · {r.updated_at.slice(0, 10)}
						</p>
					</article>
				))
			) : (
				<p>
					보낸 제보가 없어요. 이 기기에서 보낸 제보가 아니라면 표시되지 않아요.
				</p>
			)}
			<Link to="/support">문의로 돌아가기</Link>
		</section>
	);
}
